<template>
  <div class="relative w-full">
    <begin :show="isCurrent(1)" @next="next" @skip="skip" @leave="leave" />
    <component :is="isVer2 ? 'Slides2' : 'Slides'" v-show="!isCurrent(3)" :show="isCurrent(2)" @next="next" @skip="skip" @leave="leave" />
    <check :show="isCurrent(3)" @next="done" @leave="leave" />
  </div>
</template>

<script>
import page from '@/mixins/page';
import leave from '@/mixins/leave';
import audioPlayer from '@/mixins/audio-player';
import ScanProcess from '@/modules/scan-process';

import Begin from '@/components/MobileScan/Tutorial/Begin.vue';
import Slides from '@/components/MobileScan/Tutorial/Slides.vue';
import Slides2 from '@/components/MobileScan2/Tutorial/Slides.vue';
import Check from '@/components/MobileScan/Tutorial/Check.vue';

export default {
  name: 'Tutorial',
  mixins: [page, leave, audioPlayer],
  components: {
    Begin,
    Slides,
    Slides2,
    Check,
  },
  mounted() {
    this.playAudio('ms-04-wear_tight', true);
  },
  data: () => ({
    currentPageNo: 1,
    isVer2: ScanProcess.provider === 10,
  }),
  methods: {
    next() {
      const newPage = this.currentPageNo + 1;
      if (!this.lastScreen) {
        this.stopAudio();
        this.currentPageNo = newPage;
      } else {
        this.done();
      }
    },
    skip() {
      this.stopAudio();
      this.currentPageNo = 3;
    },
    done() {
      this.$events.goto(this.isVer2 ? 'MobileScan2/Scan' : 'MobileScan/Scan');
    },
    isCurrent(index) {
      return this.currentPageNo === index;
    },
  },
  computed: {
    lastScreen() {
      return this.currentPageNo === 3;
    },
  },
};
</script>

<style scoped></style>
